import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { ratePerPaxFormDefault } from "@factory/form/form.default";
import { RatePerPaxFormRule, RatePerPaxFormSchema } from "@factory/form/form.rule";
import { useQyCreateRatePerPax } from "@factory/query/rate-per-pax.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewRatePerPax() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateRatePerPax } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New RatePerPax is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addRatePerPax, isLoading: isCreating } =
    useQyCreateRatePerPax(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<RatePerPaxFormSchema>({
    defaultValues: ratePerPaxFormDefault,
    resolver: zodResolver(RatePerPaxFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: RatePerPaxFormSchema) => {
    const formData = mapCreateRatePerPax(form);
    addRatePerPax(formData);
  };
  const handleValidateError = (err: FieldErrors<RatePerPaxFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
